// extracted by mini-css-extract-plugin
export default {"description":"webpack-concepts-Extraction-Blocks-Table-control-Table-module__description","labelOuter":"webpack-concepts-Extraction-Blocks-Table-control-Table-module__labelOuter"};